interface IAppConst {
    appName: string,
    headerHeight: number,
    baseApiURL: string,
    appURLLogo: string,
    schoolCode: string,
    menuBackgroundColor: string,

    OIDC_AUTHORITY: string,
    OIDC_LOGOUT: string,
    OIDC_CLIENT_ID: string,
    OIDC_REDIRECT_URI: string,
    OIDC_CLIENT_SECRET: string,
    OIDC_SCOPE:string,
    OIDC_UNIT: string,
}
export const appConst: IAppConst = {
    appName: process.env.REACT_APP_APP_NAME?.toString() ?? "",
    headerHeight: 56,
    baseApiURL: process.env.REACT_APP_API_BASE_URL?.toString() ?? "",
    appURLLogo: process.env.REACT_APP_URL_LOGO && process.env.REACT_APP_URL_LOGO.trim() !== "" ? process.env.REACT_APP_URL_LOGO : `${process.env.REACT_APP_OIDC_AUTHORITY}/logo.png`,
    schoolCode: process.env.REACT_APP_SCHOOL_CODE?.toString().trim() ?? "",
    // Màu nền menu/sidebar; không cấu hình thì giữ mặc định như hiện tại.
    menuBackgroundColor: process.env.REACT_APP_MENU_BACKGROUND_COLOR?.toString().trim() || "#017583",
    OIDC_AUTHORITY: process.env.REACT_APP_OIDC_AUTHORITY?.toString() ?? "",
    OIDC_LOGOUT: process.env.REACT_APP_OIDC_LOGOUT?.toString() ?? "",
    OIDC_CLIENT_ID: process.env.REACT_APP_OIDC_CLIENT_ID?.toString() ?? "",
    OIDC_CLIENT_SECRET: process.env.REACT_APP_OIDC_CLIENT_SECRET?.toString() ?? "",
    OIDC_REDIRECT_URI: process.env.REACT_APP_OIDC_REDIRECT_URI?.toString() ?? "",
    OIDC_SCOPE: process.env.REACT_APP_OIDC_SCOPE?.toString().trim() || "openid profile email offline_access",
    OIDC_UNIT: process.env.REACT_APP_OIDC_UNIT?.toString() ?? "",
}